<div class="permission-page">
  <div class="d-flex justify-content-between align-items-center">
    <div class="content-search col-7">
      <div class="search-container container-form d-flex align-items-center borderInput search-full"
        *ngIf="!activeSelectList">
        <i class="fal fa-search search-icon pointer-in" (click)="searchUser(searchInput.value)"></i>
        <input #searchInput class="input-custom w-100" type="text" placeholder="Buscar usuario" [ngModel]="searchText"
          (input)="searchUser(searchInput.value)">
      </div>
      <div class="info-selected" *ngIf="activeSelectList">
        <span>Seleccionados ({{selectedItems.length}})</span>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end content-btns col-4" *ngIf="admin">
      <!-- <div class="link-open">
                <i class="fal fa-list-radio"></i>
                <span>Seleccionar varios</span>
            </div> -->
      <!--
            <div class="link-open" (click)="activeSelecting()" *ngIf="!activeSelectList ">
                <i class="fal fa-list-radio"></i>
                <span>Seleccionar varios</span>
            </div>-->
      <div class="d-flex" style="gap: 30px;" *ngIf="activeSelectList">
        <div [matMenuTriggerFor]="editOptions"
          class="btn-create btn-create-border btn-select btn-edit d-flex justify-content-between m-0"
          [class.disabled]="selectedItems.length <= 0">
          <p class="m-0">Acciones en grupo</p>
          <i class="icon-option fal fa-chevron-down"></i>
        </div>
        <mat-menu class="menu-options" #editOptions="matMenu">
          <button mat-menu-item (click)="deleteUser(selectedItems)">Eliminar</button>
        </mat-menu>
      </div>
      <div class="d-flex align-items-center" *ngIf="activeSelectList">
        <div class="btn-create btn-action m-0" (click)="activeSelecting()">
          <p class="m-0">Cancelar</p>
        </div>
      </div>
      <div class="btn-create m-0" (click)="openNewUser()" *ngIf="!activeSelectList">
        <i class="fal fa-plus-circle"></i>
        <p class="m-0">Crear usuario</p>
      </div>
    </div>
  </div>
  <div class="content-table-orders">
    <div *ngIf="loadingTable" class="container-lottie">
      <div class="loading-container">
        <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
          containerClass="loading-box"></ng-lottie>
      </div>
    </div>
    <div #containerScroll class="" *ngIf="!loadingPage" (scroll)="isScrolledInfinityView($event)">
      <div class="desktop-view d-lg-block d-none table-permission table-panel multiple-lines">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z28" matSort (matSortChange)="sortData($event)">
          <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef><b>
                <div class="d-flex align-items-center" style="gap: 10px;">
                  <mat-checkbox [(ngModel)]="allSelected" class="checkbox" color="primary" (change)="selectAll()"
                    *ngIf="activeSelectList"></mat-checkbox>
                  <span *ngIf="!activeSelectList">Acciones</span>
                </div>
              </b></th>
            <td mat-cell *matCellDef="let user">
              <mat-checkbox class="checkbox" [checked]="allSelected" color="primary" (change)="changeSelectItem(user)"
                *ngIf="activeSelectList"></mat-checkbox>

              <div class="d-flex" style="gap: 20px;" *ngIf="!activeSelectList">
                <div [matMenuTriggerFor]="actionOptions" class="pointer-in square-option">
                  <i class="icon-option fal fa-ellipsis-vertical"></i>
                </div>
                <mat-menu class="options-menu-control-panel" #actionOptions="matMenu">
                  <button mat-menu-item class="deleteIcon" *ngIf="user.active" (click)="openUser(user)">Ver<span
                      *ngIf="admin">/Editar</span></button>
                  <button mat-menu-item class="deleteIcon" (click)="deleteUser([user])" *ngIf="admin">Eliminar</button>
                </mat-menu>
                <div class="pointer-in square-option" (click)="openUser(user)" *ngIf="user.active && admin">
                  <i class="icon-option fal fa-pen"></i>
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell mat-sort-header *matHeaderCellDef><b>Correo electrónico</b></th>
            <td [class.invite]="!user.active" mat-cell *matCellDef="let user" (click)="openUser(user)">
              {{user.email||'-'}}
            </td>
          </ng-container>
          <ng-container matColumnDef="nombre">
            <th mat-header-cell mat-sort-header *matHeaderCellDef><b>Nombre y apellidos</b></th>
            <td [class.invite]="!user.active" mat-cell *matCellDef="let user" (click)="openUser(user)">
              <div>
                  <span>{{user.name||user.nombre||'-'}}</span>
                  <span class="invite-badge invite-badge--expired" *ngIf="!user.active && (user.expirationDate|date:'dd MM y HH:mm') <= (now|date:'dd MM y HH:mm')">Caducada</span>
                  <span class="invite-badge invite-badge--pending" *ngIf="!user.active && (user.expirationDate|date:'dd MM y HH:mm') > (now|date:'dd MM y HH:mm')">Pendiente</span>
                  <p *ngIf="!user.active" class="m-0 link-send-invite pointer-in" (click)="$event.stopPropagation(); openSendInvite(user)">Reenviar invitación</p>
                </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef><b>Función</b></th>
            <td [class.invite]="!user.active" mat-cell *matCellDef="let user" (click)="openUser(user)">
              {{getRolesUser(user)}}
            </td>
          </ng-container>
          <ng-container matColumnDef="place">
            <th mat-header-cell *matHeaderCellDef><b>Espacio</b></th>
            <td [class.invite]="!user.active" mat-cell *matCellDef="let user" (click)="openUser(user)">
              <div class="image-place">
                <!-- <img *ngIf="place.image" [src]="place.image" [alt]="place.name" class="icon-place" /> -->
                {{getPlacesUser(user)}}
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

      </div>

      <div class="mobile-view d-block d-lg-none">
        <div class="manager-card" *ngFor="let user of dataSource.data" (click)="openUser(user)">
          <div class="manager-card-header">
            <div class="manager-avatar">
              <img *ngIf="user.image" [src]="urlImages + user.image" class="manager-avatar-img" />
              <span *ngIf="!user.image">{{ getUserInitial(user) }}</span>
            </div>
            <div class="manager-info">
              <div class="manager-name-row">
                <span class="manager-name">{{ user.name || user.nombre || '—' }}</span>
                <span class="invite-badge invite-badge--expired" *ngIf="!user.active && (user.expirationDate|date:'dd MM y HH:mm') <= (now|date:'dd MM y HH:mm')">Caducada</span>
                <span class="invite-badge invite-badge--pending" *ngIf="!user.active && (user.expirationDate|date:'dd MM y HH:mm') > (now|date:'dd MM y HH:mm')">Pendiente</span>
              </div>
              <span class="manager-email">{{ user.email || '—' }}</span>
              <span class="resend-link" *ngIf="!user.active" (click)="$event.stopPropagation(); openSendInvite(user)">
                <i class="fa-light fa-paper-plane"></i> Reenviar invitación
              </span>
            </div>
            <i class="fa-light fa-chevron-right manager-chevron" *ngIf="user.active"></i>
          </div>
          <ng-container *ngIf="getRolesUser(user) || getPlacesUser(user)">
            <mat-divider style="margin: 12px 0 10px;"></mat-divider>
            <div class="manager-meta">
              <div class="manager-meta-item" *ngIf="getRolesUser(user)">
                <span class="manager-meta-label">Función</span>
                <span class="manager-meta-value">{{ getRolesUser(user) }}</span>
              </div>
              <div class="manager-meta-item" *ngIf="getPlacesUser(user)">
                <span class="manager-meta-label">Espacio</span>
                <span class="manager-meta-value">{{ getPlacesUser(user) }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="pagination-component">
        <div class="d-flex align-items-center pagination-panel pagination-table"
          *ngIf="!finishScroll || (!loadingPage && loadingTable)">
          <div>
            <ng-lottie class="lottie-pagination" [options]="{path: 'assets/lotties/loading.json'}"
              containerClass="loading-box"></ng-lottie>
          </div>
        </div>
      </div>
      <div class="empty-state" *ngIf="!loadingTable && !loadingPage && usersManager.length <= 0">
        <i class="fa-light fa-users-slash empty-state-icon"></i>
        <p class="empty-state-text">No hay gestores disponibles</p>
      </div>
    </div>
  </div>
</div>
